<template>
  <div class="o-limit-date">
      <div class="m-limit-date-shadow">
        <div>
          <i class="fas fa-exclamation-triangle"></i>
          <h1>
            {{ $t('oLimitDate.title.first') }} <u>{{ $store.getters.getAcademyDaysLeft }} {{ $t('oLimitDate.title.second') }}</u> {{ $t('oLimitDate.title.third') }}<br>
            {{ $t('oLimitDate.title.fourth') }}
          </h1>
          <p>{{ $t('oLimitDate.firstParagraph') }}</p>
          <router-link
            :to="`/${this.$t('rPaths.updateMyPlan')}`"
          >
            {{ $t('oLimitDate.link.first') }} <b>{{ $t('oLimitDate.link.second') }}</b> {{ $t('oLimitDate.link.third') }}
          </router-link>
          <p>{{ $t('oLimitDate.secondParagraph.first') }} <u>{{ $t('oLimitDate.secondParagraph.second') }}</u></p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'OrganismLimitDate'
}
</script>
